/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Inline_Toast_ReadyInputs */

const en_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account ready!`)
};

const es_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Cuenta lista!`)
};

const de_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto bereit!`)
};

const zh_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户已就绪！`)
};

const ar_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحساب جاهز!`)
};

const fr_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte prêt !`)
};

const vi_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản sẵn sàng!`)
};

const sw_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti tayari!`)
};

const th_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีพร้อม!`)
};

const bs_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Račun je spreman!`)
};

const ja_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントの準備ができました！`)
};

const ko_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정이 준비되었습니다!`)
};

const pt_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta pronta!`)
};

const it_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account pronto!`)
};

const sv_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto redo!`)
};

const nl_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account klaar!`)
};

const da_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontoen er klar!`)
};

const nb_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto klar!`)
};

const fi_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tili valmis!`)
};

const pl_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto gotowe!`)
};

const ru_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аккаунт готов!`)
};

const tr_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesap hazır!`)
};

const hi_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता तैयार है!`)
};

const id_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun siap!`)
};

const ms_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun sedia!`)
};

const cs_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet je připraven!`)
};

const el_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λογαριασμός έτοιμος!`)
};

const he_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`החשבון מוכן!`)
};

const af_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekening gereed!`)
};

const hu_auth_inline_toast_ready = /** @type {(inputs: Auth_Inline_Toast_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fiók elkészült!`)
};

/**
* | output |
* | --- |
* | "Account ready!" |
*
* @param {Auth_Inline_Toast_ReadyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_inline_toast_ready = /** @type {((inputs?: Auth_Inline_Toast_ReadyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Inline_Toast_ReadyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_inline_toast_ready(inputs)
	if (locale === "de") return de_auth_inline_toast_ready(inputs)
	if (locale === "zh") return zh_auth_inline_toast_ready(inputs)
	if (locale === "ar") return ar_auth_inline_toast_ready(inputs)
	if (locale === "fr") return fr_auth_inline_toast_ready(inputs)
	if (locale === "vi") return vi_auth_inline_toast_ready(inputs)
	if (locale === "sw") return sw_auth_inline_toast_ready(inputs)
	if (locale === "th") return th_auth_inline_toast_ready(inputs)
	if (locale === "bs") return bs_auth_inline_toast_ready(inputs)
	if (locale === "ja") return ja_auth_inline_toast_ready(inputs)
	if (locale === "ko") return ko_auth_inline_toast_ready(inputs)
	if (locale === "pt") return pt_auth_inline_toast_ready(inputs)
	if (locale === "it") return it_auth_inline_toast_ready(inputs)
	if (locale === "sv") return sv_auth_inline_toast_ready(inputs)
	if (locale === "nl") return nl_auth_inline_toast_ready(inputs)
	if (locale === "da") return da_auth_inline_toast_ready(inputs)
	if (locale === "nb") return nb_auth_inline_toast_ready(inputs)
	if (locale === "fi") return fi_auth_inline_toast_ready(inputs)
	if (locale === "pl") return pl_auth_inline_toast_ready(inputs)
	if (locale === "ru") return ru_auth_inline_toast_ready(inputs)
	if (locale === "tr") return tr_auth_inline_toast_ready(inputs)
	if (locale === "hi") return hi_auth_inline_toast_ready(inputs)
	if (locale === "id") return id_auth_inline_toast_ready(inputs)
	if (locale === "ms") return ms_auth_inline_toast_ready(inputs)
	if (locale === "cs") return cs_auth_inline_toast_ready(inputs)
	if (locale === "el") return el_auth_inline_toast_ready(inputs)
	if (locale === "he") return he_auth_inline_toast_ready(inputs)
	if (locale === "af") return af_auth_inline_toast_ready(inputs)
	if (locale === "hu") return hu_auth_inline_toast_ready(inputs)
	return en_auth_inline_toast_ready(inputs)
});